import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck } from '@angular/core';
import { BrowserWidthService } from "../../services/browser-width.service";

export interface ModalDialogHost {
    close?: Function,
    modalClose: EventEmitter<any>,
    readyForDestruction: EventEmitter<any>,
    init?: Function;
}


@Component({
    moduleId: module.id.toString(),
    selector: 'yeti-modal-dialog',
    template: require('./modal-dialog-frame.html'),
    styles: [require('./modal-dialog.component.scss')]
})

export class ModalDialogComponent implements OnInit, DoCheck {
    @Input() modalHeader: string;
    @Input() modalComponent: ModalDialogHost = null;
    @Input() showClose: boolean = true;
    @Input() allowEscapeClose: boolean = true;
    @Input() allowBackdropClose: boolean = true;
    @Input() adjustCss: boolean = true;

    private resizeTimerId: number = -1;
    private allowFilterClick: boolean = true;
    private previousContent: string = null;
    constructor(private _element: ElementRef, public browserWidthService: BrowserWidthService) {
    }

    ngOnInit() {
        if (this.modalComponent) {
            if (this.modalComponent.close) {
                this.close = (data: any) => {
                    this.modalComponent.close(data);
                }
            } else {
                this.modalComponent.close = (data: any) => {
                    this.close(data);
                }
            }
        }

        window.addEventListener('resize', () => {
            if (this.resizeTimerId > 0) {
                clearTimeout(this.resizeTimerId);
            }

            this.resizeTimerId = <any>setTimeout(() => {
                this.resizeTimerId = -1;
                this.adjustContentScroll();
            }, 500);
        });
    }

    ngDoCheck() {
        setTimeout(() => {
            this.adjustContentScroll();
        }, 500);
    }

    close(data?: any) {
        this.browserWidthService.modalActive$.next(false);
        this.modalComponent.readyForDestruction.emit();
        this.modalComponent.modalClose.emit(data);
    }

    closeButtonClick() {
        this.close();
    }

    filterClick() {
        if (this.allowBackdropClose && this.allowFilterClick) {
            this.close();
        }
        this.allowFilterClick = true;
    }

    cancelClick(event: MouseEvent) {
        this.allowFilterClick = false;
    }

    handleKeyEvent(event: KeyboardEvent) {
        if (event.keyCode == 27) { // ess-kah-pay key
            if (this.allowEscapeClose) {
                event.stopPropagation();
                this.close();
            }
        }
    }

    adjustContentScroll() {
        var contentElement: HTMLElement = this._element.nativeElement.querySelectorAll('.yeti-modal-body')[0]; // your rendered stuff
        var scrollingElement: HTMLElement = this._element.nativeElement.querySelectorAll('.yeti-modal-content')[0]; // wrapper of your stuff

        if (!contentElement) {
            throw "Modal body wasn't found! Please include an element with class equal to yeti-modal-body.";
        }

        var renderedHeight = contentElement.clientHeight; // how big does it want to be?
        var documentHeight = document.body.clientHeight;

        var availableHeight = documentHeight - 75 - 30;

        if (renderedHeight < availableHeight) { // not too big? let it render all the way
            scrollingElement.style.height = "auto";
        }
        else { // too big? cap the size, forcing the scroll to happen
            scrollingElement.style.height = availableHeight + "px";
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/modal-dialog/modal-dialog.component.ts